"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CSV_MAX_SIZE_MB () {
        return CSV_MAX_SIZE_MB;
    },
    get DEFAULT_MAX_SIZE_MB () {
        return DEFAULT_MAX_SIZE_MB;
    },
    get GPKG_MAX_SIZE_MB () {
        return GPKG_MAX_SIZE_MB;
    },
    get JSON_MAX_SIZE_MB () {
        return JSON_MAX_SIZE_MB;
    },
    get MAX_SIZE_PER_MIME_TYPE_IN_MB () {
        return MAX_SIZE_PER_MIME_TYPE_IN_MB;
    },
    get ONE_MB_IN_BYTES () {
        return ONE_MB_IN_BYTES;
    },
    get VIDEO_MAX_SIZE_MB () {
        return VIDEO_MAX_SIZE_MB;
    },
    get ZIP_MAX_SIZE_MB () {
        return ZIP_MAX_SIZE_MB;
    }
});
const _constants = require("../constants");
const ONE_MB_IN_BYTES = 1048576;
const DEFAULT_MAX_SIZE_MB = 30;
const VIDEO_MAX_SIZE_MB = 600;
const JSON_MAX_SIZE_MB = 100;
const CSV_MAX_SIZE_MB = 100;
const GPKG_MAX_SIZE_MB = 1000;
const ZIP_MAX_SIZE_MB = 1000;
const MAX_SIZE_PER_MIME_TYPE_IN_MB = {
    [_constants.MIME_TYPE.PDF]: DEFAULT_MAX_SIZE_MB,
    [_constants.MIME_TYPE.JPEG]: DEFAULT_MAX_SIZE_MB,
    [_constants.MIME_TYPE.PNG]: DEFAULT_MAX_SIZE_MB,
    [_constants.MIME_TYPE.JPG]: DEFAULT_MAX_SIZE_MB,
    [_constants.MIME_TYPE.JSON]: JSON_MAX_SIZE_MB,
    [_constants.MIME_TYPE.GEOJSON]: JSON_MAX_SIZE_MB,
    [_constants.MIME_TYPE.CSV]: CSV_MAX_SIZE_MB,
    [_constants.MIME_TYPE.GPKG]: GPKG_MAX_SIZE_MB,
    [_constants.MIME_TYPE.MP4]: VIDEO_MAX_SIZE_MB,
    [_constants.MIME_TYPE.MOV]: VIDEO_MAX_SIZE_MB,
    [_constants.MIME_TYPE.ZIP]: ZIP_MAX_SIZE_MB
};

//# sourceMappingURL=data:application/json;base64,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